import { TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import { PublicKey } from "@solana/web3.js";
import dayjs from "dayjs";
import { buyTickets, raffleDefaults } from "helpers/functions";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import toast from "react-hot-toast";
import NumberPicker from "react-widgets/cjs/NumberPicker";
import styled from "styled-components";

export const SPL_ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID: PublicKey = new PublicKey(
  "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
);

const RaffleDetails = ({ match }: { match: any }) => {
  const raffle = raffleDefaults.find((element) => {
    return element.raffleObjectId === match.params.id;
  });

  const { connection } = useConnection();
  const { publicKey, sendTransaction } = useWallet();

  const [value, setValue] = useState(1);
  const [discordId, setDiscordId] = useState("");
  const [userTickets, setUserTickets] = useState(null);
  const [totalTickets, setTotalTickets] = useState(null);
  const date1 = dayjs(raffle.endDate);
  const endDate = date1.diff(new Date(), "second");

  const ended = date1.diff(new Date(), "second") < 0;

  // cap total - 5000
  // cap user - 50

  async function refreshAll() {
    await getTotalTickets();
    await getUserTickets();
  }

  useEffect(() => {
    refreshAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publicKey]);

  const getTotalTickets = async () => {
    const test = await PublicKey.findProgramAddress(
      [
        new PublicKey(raffle.receiverWallet).toBuffer(),
        TOKEN_PROGRAM_ID.toBuffer(),
        new PublicKey(raffle.tokenMint).toBuffer(),
      ],
      SPL_ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID
    );

    if (test) {
      const sigs = await connection.getSignaturesForAddress(
        new PublicKey(test[0]?.toString()),
        {
          limit: 1000,
        }
      );
      const result = sigs.reduce(
        (total, currentValue) =>
          (total =
            total +
            Number(
              currentValue && raffle.raffleId.length > 1
                ? currentValue.memo.substring(13, 15) === raffle.raffleId
                  ? raffle.type === "whitelist"
                    ? currentValue.memo
                        .substring(
                          currentValue.memo.indexOf(""),
                          currentValue.memo.lastIndexOf(";")
                        )
                        .substring(18)
                    : currentValue.memo.substring(18)
                  : 0
                : currentValue.memo.substring(13, 14) === raffle.raffleId
                ? raffle.type === "whitelist"
                  ? currentValue.memo
                      .substring(
                        currentValue.memo.indexOf(""),
                        currentValue.memo.lastIndexOf(";")
                      )
                      .substring(17)
                  : currentValue.memo.substring(17)
                : 0
            )),
        0
      );
      setTotalTickets(result);
    }
  };

  const getUserTickets = async () => {
    if (publicKey) {
      const test = await PublicKey.findProgramAddress(
        [
          publicKey?.toBuffer(),
          TOKEN_PROGRAM_ID.toBuffer(),
          new PublicKey(raffle.tokenMint).toBuffer(),
        ],
        SPL_ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID
      );

      if (test) {
        const sigs = await connection.getSignaturesForAddress(
          new PublicKey(test[0]?.toString()),
          {
            limit: 1000,
          }
        );

        const result = sigs.reduce(
          (total, currentValue) =>
            (total =
              total +
              Number(
                currentValue && raffle.raffleId.length > 1
                  ? currentValue.memo?.substring(13, 15) === raffle.raffleId
                    ? raffle.type === "whitelist"
                      ? currentValue.memo
                          .substring(
                            currentValue.memo.indexOf(""),
                            currentValue.memo.lastIndexOf(";")
                          )
                          .substring(18)
                      : currentValue.memo.substring(18)
                    : 0
                  : currentValue.memo.substring(13, 14) === raffle.raffleId
                  ? raffle.type === "whitelist"
                    ? currentValue.memo
                        .substring(
                          currentValue.memo.indexOf(""),
                          currentValue.memo.lastIndexOf(";")
                        )
                        .substring(17)
                    : currentValue.memo.substring(17)
                  : 0
              )),
          0
        );
        setUserTickets(result);
      }
    }
  };

  const raffleAction = async () => {
    if (publicKey === null) {
      toast.error("Please connect your wallet.");
    } else if (raffle.type === "whitelist" && discordId === "") {
      toast.error("Please enter your Discord ID");
    } else {
      const id = toast.loading("Processing Transaction...");
      const res = await buyTickets(
        raffle,
        value,
        connection,
        publicKey,
        sendTransaction,
        raffle.type === "whitelist" && discordId
      );

      console.log({ res });
      if (res?.err === null) {
        await toast.success("Ticket Purchased.", { id });
        refreshAll();
      } else {
        toast.error("Something went wrong.", { id });
      }
    }
  };

  return (
    <RaffleDetailsContainer>
      <div>
        <RaffDetailsImg src={raffle.raffleImage} />
        <RaffleDetailsDesc>
          {/* <h3>Description</h3>
          <p dangerouslySetInnerHTML={{ __html: raffle.raffleDesc }} /> */}
          {/* <h3></h3>
          <p>Every non-winning bid will be refunded after the auction has ended. However, you can cancel your bid at any time but you will be charged 0.033 SOL (PHBT).</p> */}
        </RaffleDetailsDesc>
      </div>
      <div>
        <RaffleDetailsInfoHeader>
          <RaffleDetailsInfoTitle>
            <h3>{raffle.raffleName}</h3>
          </RaffleDetailsInfoTitle>
          <div>
            {raffle.tokenLink && (
              <a href={raffle.tokenLink} target={"_blank"} rel="noreferrer">
                View Token
              </a>
            )}
          </div>
        </RaffleDetailsInfoHeader>
        <RaffleDetailsInfoStats>
          <RaffleDetailsInfoStat>
            {!ended ? (
              <>
                <span>Ends</span>
                <p>
                  {endDate > 86400
                    ? `${(endDate / 60 / 60 / 24).toFixed(0)} days`
                    : endDate > 3600
                    ? `${(endDate / 60 / 60).toFixed(0)} hrs`
                    : endDate < 3600
                    ? `${(endDate / 60).toFixed(0)} mins`
                    : `${endDate} seconds`}
                </p>
              </>
            ) : (
              <span>Raffle closed!</span>
            )}
          </RaffleDetailsInfoStat>
          <RaffleDetailsInfoStat>
            <span>Sold Tickets</span>
            <p>{totalTickets ?? 0}</p>
          </RaffleDetailsInfoStat>
          <RaffleDetailsInfoStat>
            <span>Winners</span>
            <p>{raffle.winners}</p>
          </RaffleDetailsInfoStat>
        </RaffleDetailsInfoStats>
        {!ended ? (
          <RaffleDetailsInfoBuy>
            <p>
              1 ticket cost <span>{raffle.pricePerTicket} $MNRL</span>
            </p>
            {raffle.limit && userTickets > 0 ? (
              <p>Max 1 entry</p>
            ) : (
              <RaffleDetailsButtonContainer>
                <RaffleDetailsPickerContainer>
                  <NumberPicker
                    defaultValue={1}
                    min={1}
                    max={raffle.limit && 1}
                    value={value}
                    onChange={(value) => setValue(value)}
                  />
                </RaffleDetailsPickerContainer>
                {raffle.type === "whitelist" && (
                  <Form.Group
                    controlId="formBasicEmail"
                    style={{ margin: 0, maxWidth: 200, marginRight: 24 }}
                  >
                    <Form.Control
                      type="text"
                      placeholder="Enter Discord ID"
                      onChange={(e) => setDiscordId(e.target.value)}
                      defaultValue={discordId}
                    />
                  </Form.Group>
                )}
                <button className="button" onClick={() => raffleAction()}>
                  Purchase
                </button>
              </RaffleDetailsButtonContainer>
            )}
            {userTickets > 0 && (
              <p
                style={{
                  fontSize: 18,
                  color: "#ccc",
                  marginBottom: 0,
                  marginTop: 18,
                }}
              >
                You have purchased {userTickets ?? 0} tickets!
              </p>
            )}
          </RaffleDetailsInfoBuy>
        ) : (
          <RaffleDetailsInfoBuy>
            <p>Raffle closed!</p>
            <p>🎉 Congrats to the winner 🎉</p>
            <ul>
              {raffle.winner?.map((winner) => (
                <p>{winner}</p>
              ))}
            </ul>
          </RaffleDetailsInfoBuy>
        )}
      </div>
    </RaffleDetailsContainer>
  );
};

export default RaffleDetails;

const RaffleDetailsContainer = styled.div`
  display: grid;
  grid-gap: 32px;

  @media only screen and (min-width: 768px) {
    grid-template-columns: 320px 1fr;
  }
`;

const RaffDetailsImg = styled.img`
  border-radius: 16px;
  height: 320px;
  margin-bottom: 32px;
  width: 320px;
`;

const RaffleDetailsDesc = styled.div`
  h3 {
    color #fff;
    font-family: "Oswald";
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  p {
    color: #cccccc;
    font-family: "Work Sans";
    font-size: 18px;
    font-weight: 600;
    line-height: 1.3;
  }
`;

const RaffleDetailsInfoHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;

  a {
    color: #fff;
    font-size: 20px;
    font-weight: 600;
    text-decoration: underline;
  }
`;

const RaffleDetailsInfoTitle = styled.div`
  align-items: center;
  display: flex;

  h3 {
    color #fff;
    font-family: "Oswald";
    font-size: 32px;
    font-weight: 600;
    margin: 0;
  }

  ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      margin-left: 16px;
    }
  }
`;

const RaffleDetailsInfoStats = styled.div`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(3, 1fr);
  margin-bottom: 16px;
  text-align: left;
`;

const RaffleDetailsInfoStat = styled.div`
  /* background: #222; */
  /* backdrop-filter: blur(15px); */
  /* box-shadow: 0px 4px 70px rgba(0, 0, 0, 0.1), */
  /* 0px 0px 0px 2px rgba(255, 255, 255, 0.2); */
  /* border-radius: 16px; */
  display: flex;
  flex-direction: column;
  /* height: 120px; */
  justify-content: start;

  span {
    color: #cccccc;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  p {
    color: #fff;
    font-family: "Oswald";
    font-size: 24px;
    font-weight: 600;
    margin: 0;
  }
`;

const RaffleDetailsInfoBuy = styled.div`
  /* background: #222; */
  /* backdrop-filter: blur(15px); */
  /* box-shadow: 0px 4px 70px rgba(0, 0, 0, 0.1), */
  /* 0px 0px 0px 2px rgba(255, 255, 255, 0.2); */
  /* border-radius: 16px; */
  display: flex;
  flex-direction: column;
  /* height: 200px; */
  justify-content: center;
  padding: 24px 0;
  text-align: left;

  p {
    color: #fff;
    font-family: "Oswald";
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 16px;
  }
`;

const RaffleDetailsButtonContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: start;
  margin-top: 12px;

  .button {
    background: rgb(70, 130, 180);
    border: 0;
    border-radius: 10px;
    color: #fff;
    font-family: "Oswald";
    font-size: 24px;
    font-weight: 600;
    height: 56px;
    padding-left: 24px;
    padding-right: 24px;
    text-align: left;
  }
`;

const RaffleDetailsPickerContainer = styled.div`
  margin-right: 24px;
  max-width: 120px;
`;
